<template>
  <div class="main">
    <Header 
      :show="true"
      title="卸料罐口"
      left="prepage" 
      right="" 
      :click-left="handleClickLeft" 
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh;">
      <van-notice-bar
        wrapable
        :scrollable="false"
        left-icon="info-o"
        text="配置罐口指定的粉料"
      />
      <el-table
        ref="table"
        :data="table.data"
        :row-key="handleRowKey"
        :expand-row-keys="expandRowKeys"
        :row-class-name="handleRowClassName"
        :cell-style="handleCellStyle"
        @row-click="handleTableRowClick"
      >
        <el-table-column type="expand" width="30px">
          <template slot-scope="{row}">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item label="序号">
                <span>{{ row.id }}</span>
              </el-form-item>
              <el-form-item label="名称">
                <span>{{ row.name }}</span>
              </el-form-item>
              <el-form-item label="物料">
                <span>{{ row.material }}</span>
              </el-form-item>
              <el-form-item label="当前值">
                <span>{{ row.capacity }}吨</span>
              </el-form-item>
              <el-form-item label="额定容量">
                <span>{{ row.totalCapacity }}吨</span>
              </el-form-item>
              <el-form-item label="灌料阀值">
                <span>{{ row.lowerCapacity }}吨</span>
              </el-form-item>
              <el-form-item label="说明">
                <span>{{ row.remark }}</span>
              </el-form-item>
              <el-form-item label="状态">
                <el-tag v-if="row.status === '工作'" size="small" type="warning">{{ row.status }}</el-tag>
                <el-tag v-else size="small" type="success">{{ row.status }}</el-tag>
              </el-form-item>
              <el-form-item label="操作" v-if="checkPermission([132]) || checkPermission([133])" >
                <el-button v-if="checkPermission([133])" type="warning" size="mini" @click="handleClickUpdateCapacity(row)">
                  盘点
                </el-button>
                <el-button v-if="checkPermission([132])" type="primary" size="mini" @click="handleClickUpdate(row)">
                  编辑
                </el-button>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column label="序号" prop="id" align="center" width="50">
          <template slot-scope="{row}">
            {{ row.id }}
          </template>
        </el-table-column>
        <el-table-column label="名称" prop="name" align="center" min-width="80">
          <template slot-scope="{row}">
            {{ row.name }}
          </template>
        </el-table-column>
        <el-table-column label="物料" prop="material" align="center" min-width="100" show-overflow-tooltip>
          <template slot-scope="{row}">
            {{ row.material }}
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="status" align="center" min-width="100" show-overflow-tooltip>
          <template slot-scope="{row}">
            <el-tag v-if="row.status === '工作'" size="medium" type="warning">{{ row.status }}</el-tag>
            <el-tag v-else size="medium" type="success">{{ row.status }}</el-tag>
          </template>
        </el-table-column>
      </el-table>
      
      <van-dialog
        v-model="dialogVisibleUpdateCapacity" 
        title="料仓盘点"
        show-cancel-button
        :before-close="handleClickUpdateCapacityConfirm"
      >
        <van-field
          ref="name"
          v-model="listQuery.name"
          label="罐口名称"
          placeholder="请选择罐口名称"
          required
          readonly
        />
        <van-field
          ref="capacity"
          v-model="listQuery.capacity"
          label="当前库存"
          placeholder="请输入料仓当前库存"
          required
          :rules="[{ validator: validNumberFloat, message: '' }]"
        />
      </van-dialog>
    </div>
    <Footer value="service" />
  </div>
</template>

<script>

  import { Dialog } from 'vant'
  import { showPhoneAlarm } from '@/global/function.js'
  import { isNumberFloat } from '@/utils/validate.js'
  import checkPermission from '@/utils/permission'
  import Header from '@/views/components/header/index.vue'
  import Footer from '@/views/components/footer/index.vue'
  import { getConfigList, updateConfigOne } from '@/api/port.js'

  export default {
    name: "ServiceProjectPort",
    components: {
      Header,
      Footer
    },
    inject: ['reload'],
    data() {
      return {
        dialogVisibleUpdateCapacity: false,
        listQuery: {
          limit: 10,
          page: 1,
          serial: null,
          name: '',
          capacity: 0
        },
        isLoading: false,
        table: {
          listLoading: false,
          fullWidth: document.documentElement.clientWidth,
          key: 0,
          total: 0,
          data: []
        },
        expandRowKeys: [],
        handleRowKey(row) {
          return row.id
        }
      }
    },
    computed: {

    },
    watch: {
      
    },
    beforeCreate() {
      
    },
    created() {
      this.handleClickQuery()
    },
    beforeMount() {
      
    },
    mounted() {
      
    },
    beforeUpdate() {
      
    },
    updated() {
      
    },
    beforeDestroy() {
      
    },
    destroyed() {
      
    },
    methods: {
      checkPermission,
      handleClickLeft() {
        this.$router.go(-1)
        // console.log('dashboard-left')
      },
      handleClickRight() {
        this.$router.push({ 
          path:'/service/project/port/update', 
          query: {} ,
        })
      },
      handleTableRowClick(row, column, event) {
        this.$refs.table.toggleRowExpansion(row)
      },
      handleRowClassName({row, rowIndex}) {
        return 'normal-row'
      },
      handleCellStyle({ row, column, rowIndex, columnIndex }) {
        return ''
      },
      onRefresh() {
        setTimeout(() => {
          this.isLoading = false
          showPhoneAlarm(true, 'toast', null, 2000, null, '工程配置', '刷新完成')
        }, 1000)
      },
      validNumberFloat(value) {
        return new Promise((resolve) => {
          const result = isNumberFloat(value)
          if (result === true) {
            resolve(true)
          } else {
            showPhoneAlarm(true, 'toast', null, 2000, null, result, null)
            resolve(false)
          }
        })
      },
      handleClickQuery() {
        const data = {}
        getConfigList(data).then(response => {
          const { data } = response
          if (showPhoneAlarm(false, 'toast', null, 2000, data.code, null, data.message)) {
            const items = data.data
            this.table.data = []
            for (let i=0; i<items.length; i++) {
              this.table.data.push({
                id: this.listQuery.limit * (this.listQuery.page - 1) + i + 1,
                serial: items[i].id,
                name: items[i].portName,
                material: items[i].materialName,
                capacity: items[i].capacity,
                totalCapacity: items[i].totalCapacity,
                lowerCapacity: items[i].lowerCapacity,
                status: items[i].using === true ? '工作' : '空闲',
                remark: items[i].remark
              })
            }
          }
        }).catch(function(error) {
          console.error(error)
        })
      },
      handleClickUpdateCapacity(row) {
        this.listQuery.serial = row.serial
        this.listQuery.name = row.name
        this.listQuery.capacity = row.capacity
        this.dialogVisibleUpdateCapacity = true
      },
      handleClickUpdateCapacityConfirm(action, done) {
        if (action === 'confirm') {
          const data = {
            id: this.listQuery.serial,
            capacity: this.listQuery.capacity
          }
          this.loading = true
          updateConfigOne(data).then(response => {
            const { data } = response
            showPhoneAlarm(true, 'toast', null, 2000, data.code, '料仓盘点', data.message)
            this.handleClickQuery()
            this.dialogVisibleUpdate = false
            this.loading = false
          }).catch(function(error) {
            this.loading = false
            console.error(error)
          })
        } else {
          showPhoneAlarm(true, 'toast', 'success', 2000, 200, null, '取消盘点')
          done(true)
        }
      },
      handleClickUpdate(row) {
        this.$router.push({ path:'/service/project/port/update', query: row })
      }
    }
  }
</script>

<style scoped lang="scss">
  ::v-deep .el-form-item__label {
    width: 20%;
    text-align: right;
    // margin-right: 20px;
  }
  ::v-deep .el-table__expanded-cell[class*=cell] {
    padding: 20px 10px;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 100%;
  }
  ::v-deep .van-cell__title {
    max-width: 30%;
  }
  ::v-deep .van-cell__value {
    max-width: 70%;
  }
  ::v-deep .el-table th>.cell {
    padding-left: 5px;
    padding-right: 5px;
  }
  ::v-deep .el-table td>.cell {
    padding-left: 5px;
    padding-right: 5px;
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  // 自定义样式
  .main {
    height: 100vh;
    font-size: 2vw;
    background-color: #FFFFFF;//#F7F8FA; 
    overflow-x: hidden;
    // overflow-y:hidden;
    overflow-y: auto;
    // display: flex; 
    // justify-content: center; 
    // align-items: center;
  }
</style>
